var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.fieldRec.display_value ? _vm.fieldRec.display_value : _vm.fieldRec.value),expression:"fieldRec.display_value ? fieldRec.display_value : fieldRec.value"}],staticClass:"displayfield",style:({
        height: _vm.height ? _vm.height+'px' : undefined,
        textAlign: _vm.fieldRec.value_align || 'left',
        fontSize: _vm.fieldRec.font_size ? _vm.fieldRec.font_size+'px': null
    })})}
var staticRenderFns = []

export { render, staticRenderFns }